import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import "./Breadcrumb.styles.css";
import BreadcrumbContextApi from "../../context/BreadcrumbContextApi.context";

const Breadcrumb = ({ data }) => {
  const [searchParams] = useSearchParams();
  const { modalIsOpenHander } = React.useContext(BreadcrumbContextApi);
  const windowSize = useWindowSize();
  const location = useLocation();
  const getRefId = searchParams.get("refId");

  const loadBreadcrumb = () => {
    return data.map((el, index) => {
      let innerStruct = "";
      if (el.iconClass) {
        innerStruct = <FontAwesomeIcon icon={el.iconClass} />;
      } else {
        innerStruct = <span className="cm-sm-txt">{el.label}</span>;
      }

      if (!!el.link) {
        return (
          <span key={index}>
            <Link
              to={el.link + `${getRefId ? `?refId=${getRefId}` : ""}`}
              className="text-blue-800 cm-sm-txt"
            >
              {innerStruct}
            </Link>
            {index < data.length - 1 && (
              <FontAwesomeIcon icon={regular("angle-right")} className="px-2" />
            )}
          </span>
        );
      } else {
        return (
          <span key={index}>
            <span className="text-blue-800 cm-sm-txt">{innerStruct}</span>
          </span>
        );
      }
    });
  };

  return (
    <div className="cm-breadcrumb-container px-4 py-3 bg-white d-flex">
      <div className="px-3 cm-truncate-1 flex-grow-1">{loadBreadcrumb()}</div>
      {windowSize.isMobile && ["/profile"].includes(location.pathname) && (
        <FontAwesomeIcon
          icon={regular("bars")}
          className="my-auto cm-pointer"
          onClick={() => {
            modalIsOpenHander();
          }}
        />
      )}
    </div>
  );
};

export default Breadcrumb;
